<template>
    <el-tabs class="m-database-tabs" v-model="typeModel" type="card" @tab-click="changeType">
        <el-tab-pane label="Buff" name="buff">
            <span slot="label">
                <svg height="640" viewBox="0 0 480 480.01" width="640" xmlns="http://www.w3.org/2000/svg" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M400.117 353.61l13.977 38.687a23.992 23.992 0 01-1.559 19.707 24 24 0 01-15.82 11.855 701.88 701.88 0 01-156.711 16.149 704.609 704.609 0 01-157.32-16.278 23.721 23.721 0 01-15.438-11.656 24.36 24.36 0 01-1.539-19.832l13.496-38.496c-46.992 12.16-79.2 30.39-79.2 54.262 0 46.8 123.68 72 240 72 116.321 0 240-25.2 240-72 0-24-32.534-42.285-79.886-54.399zm0 0"/><path d="M86.406 408.168a687.757 687.757 0 00153.598 15.84c51.555.504 103-4.809 153.36-15.84a7.992 7.992 0 005.679-10.477l-10.293-28.503a704.722 704.722 0 01-148.746 14.82 703.391 703.391 0 01-149.23-14.934L80.726 397.77a8.007 8.007 0 00.476 6.48c1.086 2 2.98 3.43 5.203 3.918zm0 0M383.277 354.035L315.285 165.77a136.138 136.138 0 01-4.664-15.88l-41.703 32.438-9.824-12.637 44.047-34.257-56.192-7.497 2.113-15.855 58.133 7.75c-.015-5.715.332-11.43 1.051-17.102l11.68-93.761a8 8 0 00-4-7.918 7.842 7.842 0 00-8.883.719l-87.68 70.16a151.83 151.83 0 00-48.558 68.48l-74.72 213.473a664.153 664.153 0 00143.919 14.125 665.606 665.606 0 00143.273-13.973zm-172.71-23.945a8.006 8.006 0 01-3.204-7.84l4.082-23.36-17.039-16.562a7.942 7.942 0 01-2-8.16 8.07 8.07 0 016.48-5.52l23.438-3.359 10.48-21.281a8.39 8.39 0 017.2-4.078 8.385 8.385 0 017.2 4.078l10.48 21.281 23.441 3.36a8.076 8.076 0 016.48 5.519 7.958 7.958 0 01-2 8.16l-17.039 16.563 4.079 23.359a8.003 8.003 0 01-3.2 7.84 7.91 7.91 0 01-4.718 1.52 8.959 8.959 0 01-3.762-.88l-20.961-11.039-20.961 11.04a8.283 8.283 0 01-8.477-.641zm0 0"/></svg>
                <b>Buff</b>
                <em class="u-count">{{ stat.buff }}</em>
            </span>
        </el-tab-pane>
        <el-tab-pane label="技能" name="skill">
            <span slot="label">
                <svg xmlns="http://www.w3.org/2000/svg" width="467.374" height="467.374" viewBox="0 0 467.374 467.374" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M459.657 82.222c0-5.136-1.704-9.419-5.133-12.843l-56.531-56.531c-3.425-3.427-7.706-5.14-12.847-5.14-5.144 0-9.421 1.713-12.847 5.14L5.14 380.005C1.709 383.434 0 387.719 0 392.858c0 5.141 1.709 9.418 5.14 12.847l56.529 56.527c3.431 3.429 7.708 5.141 12.85 5.141 5.137 0 9.419-1.704 12.847-5.141l367.162-367.16c3.425-3.43 5.129-7.708 5.129-12.85zm-127.619 83.655l-30.546-30.55 83.651-83.654 30.546 30.549-83.651 83.655zM65.384 73.087l8.564-27.978 27.977-8.564-27.977-8.566L65.384.001l-8.566 27.978-27.978 8.566 27.978 8.564zM139.61 108.494l17.133 55.961 17.133-55.961 55.959-17.133-55.959-17.131-17.133-55.961L139.61 74.23 83.651 91.361zM439.392 210.7l-8.563-27.977-8.562 27.977-27.98 8.565 27.98 8.565 8.562 27.975 8.563-27.975 27.982-8.565zM248.106 73.087l8.566-27.978 27.976-8.564-27.976-8.566L248.106.001l-8.562 27.978-27.98 8.566 27.98 8.564z"/></svg>
                <b>技能</b>
                <em class="u-count">{{ stat.skill }}</em>
            </span>
        </el-tab-pane>
        <el-tab-pane label="NPC" name="npc">
            <span slot="label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 833.7 833.7" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M415.5 88.8C252.9 88.8 121 220.7 121 383.4v138.8c0 7.3 3.4 14.2 9.3 18.7L256.9 637v79.2c0 13 10.5 23.4 23.4 23.4h18.8c13 0 23.4-10.5 23.4-23.4V684c0-8.2 6.6-14.8 14.8-14.8 8.2 0 14.8 6.6 14.8 14.8v32.2c0 13 10.5 23.4 23.4 23.4h.8c13 0 23.4-10.5 23.4-23.4V684c0-8.2 6.6-14.8 14.8-14.8h1.6c8.2 0 14.8 6.6 14.8 14.8v32.2c0 13 10.5 23.4 23.4 23.4h.8c13 0 23.4-10.5 23.4-23.4V684c0-8.2 6.6-14.8 14.8-14.8 8.2 0 14.8 6.6 14.8 14.8v32.2c0 13 10.5 23.4 23.4 23.4h18.9c13 0 23.4-10.5 23.4-23.4v-79.3l126.6-96.1c5.9-4.5 9.3-11.3 9.3-18.7V383.4C710 220.7 578.1 88.8 415.5 88.8zM292.4 524.5c-44.8 0-81.2-36.4-81.2-81.2 0-44.8 36.4-81.2 81.2-81.2s81.2 36.4 81.2 81.2c0 44.9-36.4 81.2-81.2 81.2zm146.2 59.7h-46.1c-10.7 0-17.5-11.5-12.3-20.8l23.1-41.9c5.3-9.7 19.3-9.7 24.6 0l23.1 41.9c5 9.4-1.8 20.8-12.4 20.8zm100-59.7c-44.8 0-81.2-36.4-81.2-81.2 0-44.8 36.4-81.2 81.2-81.2 44.8 0 81.2 36.4 81.2 81.2 0 44.9-36.3 81.2-81.2 81.2z"/></svg>
                <b>NPC</b>
                <em class="u-count">{{ stat.npc }}</em>
            </span>
        </el-tab-pane>
        <el-tab-pane label="交互物件" name="doodad">
            <span slot="label">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M188.2 470.4h89.9c32.7 0 61.1-12.4 82.1-35.7 18.2-20.2 29.1-47.1 31.4-76.7.1-.9-1.2-1.3-1.6-.5-24.4 47.2-73.6 79.6-130.4 79.6h-112c-1.9 0-3.1 1.9-2.4 3.6 2.3 5.8 5.8 11.1 10.3 15.7 8.8 9 20.4 14 32.7 14z"/><path d="M377 305.7c.5-3.7-3.1-6.6-6.6-5.4-8.6 2.9-17.8 4.4-27.4 4.4H171.7c-44.9 0-81.4 36.4-81.4 81.4v13.5c0 5.1 4.1 9.1 9.1 9.1h160.2c60.2.1 109.9-44.9 117.4-103zM418.4 107.5V48.7c0-3-2.6-5.3-5.6-5-49.6 5.3-89.8 43.7-99 92a9.12 9.12 0 009 10.9h56.5c21.5 0 39.1-17.5 39.1-39.1zM401.5 177.9c0-3.3-3.1-5.7-6.2-4.9-5.2 1.3-10.5 2-16.1 2h-81.7c-23.7 0-46 9.2-62.9 25.9s-26.3 38.8-26.3 62.3v4.1c0 5.1 4.1 9.1 9.1 9.1H343c15 0 28.7-5.7 39.1-15l.6-.6c11.6-10.7 18.9-26 18.9-43l-.1-39.9z"/></svg>
                <b>交互物件</b>
                <em class="u-count">{{ stat.doodad }}</em>
            </span>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
import { mapState } from "vuex";

export default {
    name: "DatabaseTabs",
    props: {
        client: {
            type: String,
            default: "std",
        },
        type: {
            type: String,
            default: "std",
        },
        hasRight: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: "type",
        event: "change",
    },
    computed: {
        ...mapState(["database_stat"]),
        stat() {
            return this.database_stat.count;
        },
        typeModel: {
            get() {
                return this.type;
            },
            set(val) {
                this.$emit("update:type", val);
            },
        },
    },
    methods: {
        changeType() {
            this.$emit("change", this.type);
        },
    },
};
</script>
<style lang="less">
.m-database-tabs {
    .el-tabs__item {
        user-select: none;

        a {
            color: @color;
        }
    }

    .u-icon {
        .size(20px);
        .y(-3px);
        .mr(5px);
    }
    .u-count {
        font-style: normal;
        font-weight: normal;
        .fz(12px);
        color: #888;
        &:before {
            content: "(";
            padding: 0 3px 0 5px;
        }
        &:after {
            content: ")";
            padding: 0 3px 0 5px;
        }
    }
    .is-active {
        color: @primary;
        svg {
            fill: @primary;
        }
    }
    &.el-tabs--card > .el-tabs__header .el-tabs__item {
        transition: none;
    }
    .el-tabs__item:hover {
        svg {
            fill: @primary;
        }
        color: @primary;
        a {
            color: @primary;
        }
    }
    .u-tip {
        padding: 10px 0;
        a {
            color: @primary;
            .underline(@primary);
        }
    }
}
</style>
